import { render, staticRenderFns } from "./cardUserBasicInfo.vue?vue&type=template&id=74562ad8&"
import script from "./cardUserBasicInfo.vue?vue&type=script&lang=js&"
export * from "./cardUserBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./cardUserBasicInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports